import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleNavLinkClick = () => {
    setIsMenuOpen(false);
  };
  return <header className="sticky top-0 z-50 w-full border-b border-purple-200 bg-white/90 backdrop-blur-md" data-id="element-62">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between" data-id="element-63">
        <Link to="/" className="flex items-center" data-id="element-64">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2ue9VawhEmndCoNkittRtk/eedi.png" alt="Eedi Logo" className="h-8 mr-2" data-id="element-65" />
        </Link>
        {/* Mobile menu button */}
        <button className="md:hidden p-1 rounded-md hover:bg-gray-100 transition-colors" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-66">
          <Menu size={24} data-id="element-67" />
        </button>
        {/* Desktop navigation */}
        <nav className="hidden md:flex items-center space-x-6" data-id="element-68">
          <Link to="/" className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-69">
            Home
          </Link>
          <a href="/#about-eedi" className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-70">
            About
          </a>
          <a href="/#team" className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-71">
            Team
          </a>
          <Link to="/faq" className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-72">
            FAQs
          </Link>
          <div className="bg-gradient-to-r from-purple-100 to-blue-100 text-purple-800 text-sm font-medium px-4 py-1.5 rounded-full shadow-sm" data-id="element-73">
            KS3 Maths Research Study
          </div>
        </nav>
        {/* Mobile navigation */}
        {isMenuOpen && <div className="absolute top-full left-0 right-0 bg-white shadow-md md:hidden z-50" data-id="element-74">
            <div className="container mx-auto px-4 py-3 flex flex-col space-y-3" data-id="element-75">
              <Link to="/" className="text-gray-700 hover:text-purple-600 font-medium py-2" onClick={handleNavLinkClick} data-id="element-76">
                Home
              </Link>
              <a href="/#about-eedi" className="text-gray-700 hover:text-purple-600 font-medium py-2" onClick={handleNavLinkClick} data-id="element-77">
                About
              </a>
              <a href="/#team" className="text-gray-700 hover:text-purple-600 font-medium py-2" onClick={handleNavLinkClick} data-id="element-78">
                Team
              </a>
              <Link to="/faq" className="text-gray-700 hover:text-purple-600 font-medium py-2" onClick={handleNavLinkClick} data-id="element-79">
                FAQs
              </Link>
              <div className="bg-gradient-to-r from-purple-100 to-blue-100 text-purple-800 text-sm font-medium px-4 py-2 rounded-full inline-block shadow-sm" data-id="element-80">
                KS3 Maths Research Study
              </div>
            </div>
          </div>}
      </div>
    </header>;
}